import React from "react";
import { Link } from "react-router-dom";
import { StarMotif } from "./StarMotif";

export function Logo({ variant = "dark", withWordmark = true, className = "" }) {
    // variant: "dark" (dark text — for light backgrounds) | "light" (white text — for dark backgrounds)
    return (
        <Link
            to="/"
            data-testid="brand-logo"
            className={`inline-flex items-center gap-2.5 group ${className}`}
            aria-label="RKS Systems — Home"
        >
            <span className="relative inline-flex h-10 w-10 items-center justify-center">
                <StarMotif className="h-10 w-10 text-primary transition-transform duration-500 group-hover:rotate-12" label="RKS" labelColor="#ffffff" />
            </span>
            {withWordmark && (
                <span className={`font-heading font-extrabold tracking-tight text-lg whitespace-nowrap ${variant === "light" ? "text-white" : "text-primary"}`}>
                    RKS Systems
                </span>
            )}
        </Link>
    );
}

export default Logo;
